import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const atbCarouselsHomepageSelector = createSelector(testTargetOffersSelector, offers => offers.atbCarouselsHomepage || Empty.Object);

export { atbCarouselsHomepageSelector };
